module.exports = __webpack_public_path__ + "static/media/WordBountyVote.d722b5e4.PNG";